import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class MarketTodoApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'market-todo'
  }

}